import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_ROUTES,
  GPX_FEATURES,
  GPX_PARTNERS,
} from '@rsos/gainsight';

const CHAT_EVENT_NAMES = {
  END_CHAT: 'server_end_chat',
  NEW_MESSAGE: 'server_new_message',
};

/**
 * Tracks when a chat session is ended by the server
 * @param {Object} params - The parameters for tracking the server-ended chat
 * @param {string} params.feature - The feature identifier (TF911 or TF911_OUTBOUND)
 * @param {string} params.capability - The capability identifier (TF911 or TT911)
 * @param {string} params.conversationId - The ID of the conversation that was ended
 */
export const trackEndChatFromServer = ({
  feature,
  capability,
  conversationId,
}) => {
  gspx.trackEvent({
    name: CHAT_EVENT_NAMES.END_CHAT,
    type: GPX_EVENT_TYPES.API_PUSH,
    feature,
    capability,
    route: GPX_ROUTES.COMMUNICATOR,
    partner: feature === GPX_FEATURES.RCS911 ? GPX_PARTNERS.GOOGLE : undefined,
    entities: {
      conversation_id: conversationId,
    },
  });
};

/**
 * Tracks when a new message is received from the server
 * @param {Object} params - The parameters for tracking the server-received message
 * @param {string} params.feature - The feature identifier (TF911 or TF911_OUTBOUND)
 * @param {string} params.capability - The capability identifier (TF911 or TT911)
 * @param {string} params.conversationId - The ID of the conversation that received the message
 */
export const trackNewMessageFromServer = ({
  feature,
  capability,
  conversationId,
}) => {
  gspx.trackEvent({
    name: CHAT_EVENT_NAMES.NEW_MESSAGE,
    type: GPX_EVENT_TYPES.API_PUSH,
    feature,
    capability,
    route: GPX_ROUTES.COMMUNICATOR,
    partner: feature === GPX_FEATURES.RCS911 ? GPX_PARTNERS.GOOGLE : undefined,
    entities: {
      conversation_id: conversationId,
    },
  });
};
